window.theme = window.theme || {}, window.theme = window.theme || {}, theme.Sections = function() {
		this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
	}, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
		_createInstance: function(container, constructor) {
			var $container = $(container),
				id = $container.attr("data-section-id"),
				type = $container.attr("data-section-type");
			if (constructor = constructor || this.constructors[type], !_.isUndefined(constructor)) {
				var instance = _.assignIn(new constructor(container), {
					id,
					type,
					container
				});
				this.instances.push(instance)
			}
		},
		_onSectionLoad: function(evt) {
			var container = $("[data-section-id]", evt.target)[0];
			container && this._createInstance(container)
		},
		_onSectionUnload: function(evt) {
			this.instances = _.filter(this.instances, function(instance) {
				var isEventInstance = instance.id === evt.detail.sectionId;
				return isEventInstance && _.isFunction(instance.onUnload) && instance.onUnload(evt), !isEventInstance
			})
		},
		_onSelect: function(evt) {
			var instance = _.find(this.instances, function(instance2) {
				return instance2.id === evt.detail.sectionId
			});
			!_.isUndefined(instance) && _.isFunction(instance.onSelect) && instance.onSelect(evt)
		},
		_onDeselect: function(evt) {
			var instance = _.find(this.instances, function(instance2) {
				return instance2.id === evt.detail.sectionId
			});
			!_.isUndefined(instance) && _.isFunction(instance.onDeselect) && instance.onDeselect(evt)
		},
		_onBlockSelect: function(evt) {
			var instance = _.find(this.instances, function(instance2) {
				return instance2.id === evt.detail.sectionId
			});
			!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect) && instance.onBlockSelect(evt)
		},
		_onBlockDeselect: function(evt) {
			var instance = _.find(this.instances, function(instance2) {
				return instance2.id === evt.detail.sectionId
			});
			!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect) && instance.onBlockDeselect(evt)
		},
		register: function(type, constructor) {
			this.constructors[type] = constructor, $("[data-section-type=" + type + "]").each(function(index, container) {
				this._createInstance(container, constructor)
			}.bind(this))
		}
	}), window.slate = window.slate || {}, slate.rte = {
		wrapTable: function() {
			$(".rte table").wrap('<div class="rte__table-wrapper"></div>')
		},
		iframeReset: function() {
			var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
				$iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");
			$iframeVideo.each(function() {
				$(this).wrap('<div class="video-wrapper"></div>')
			}), $iframeReset.each(function() {
				this.src = this.src
			})
		}
	}, window.slate = window.slate || {}, slate.a11y = {
		pageLinkFocus: function($element) {
			var focusClass = "js-focus-hidden";
			$element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);

			function callback() {
				$element.first().removeClass(focusClass).removeAttr("tabindex")
			}
		},
		focusHash: function() {
			var hash = window.location.hash;
			hash && document.getElementById(hash.slice(1)) && this.pageLinkFocus($(hash))
		},
		trapFocus: function(options) {
			var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
			options.$elementToFocus || (options.$elementToFocus = options.$container), options.$container.attr("tabindex", "-1"), options.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(eventName, function(evt) {
				options.$container[0] !== evt.target && !options.$container.has(evt.target).length && options.$container.focus()
			})
		},
		removeTrapFocus: function(options) {
			var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
			options.$container && options.$container.length && options.$container.removeAttr("tabindex"), $(document).off(eventName)
		}
	}, theme.Images = function() {
		function preload(images, size) {
			typeof images == "string" && (images = [images]);
			for (var i = 0; i < images.length; i++) {
				var image = images[i];
				this.loadImage(this.getSizedImageUrl(image, size))
			}
		}

		function loadImage(path) {
			new Image().src = path
		}

		function switchImage(image, element, callback) {
			var size = this.imageSize(element.src),
				imageUrl = this.getSizedImageUrl(image.src, size);
			callback ? callback(imageUrl, image, element) : element.src = imageUrl
		}

		function imageSize(src) {
			var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
			return match !== null ? match[1] : null
		}

		function getSizedImageUrl(src, size) {
			if (size == null) return src;
			if (size === "master") return this.removeProtocol(src);
			var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
			if (match != null) {
				var prefix = src.split(match[0]),
					suffix = match[0];
				return this.removeProtocol(prefix[0] + "_" + size + suffix)
			}
			return null
		}

		function removeProtocol(path) {
			return path.replace(/http(s)?:/, "")
		}
		return {
			preload,
			loadImage,
			switchImage,
			imageSize,
			getSizedImageUrl,
			removeProtocol
		}
	}(), theme.Currency = function() {
		var moneyFormat = "${{amount}}";

		function formatMoney(cents, format) {
			typeof cents == "string" && (cents = cents.replace(".", ""));
			var value = "",
				placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
				formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				if (precision = precision || 2, thousands = thousands || ",", decimal = decimal || ".", isNaN(number) || number == null) return 0;
				number = (number / 100).toFixed(precision);
				var parts = number.split("."),
					dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
					centsAmount = parts[1] ? decimal + parts[1] : "";
				return dollarsAmount + centsAmount
			}
			switch (formatString.match(placeholderRegex)[1]) {
				case "amount":
					value = formatWithDelimiters(cents, 2);
					break;
				case "amount_no_decimals":
					value = formatWithDelimiters(cents, 0);
					break;
				case "amount_with_comma_separator":
					value = formatWithDelimiters(cents, 2, ".", ",");
					break;
				case "amount_no_decimals_with_comma_separator":
					value = formatWithDelimiters(cents, 0, ".", ",");
					break;
				case "amount_no_decimals_with_space_separator":
					value = formatWithDelimiters(cents, 0, " ");
					break
			}
			return formatString.replace(placeholderRegex, value)
		}
		return {
			formatMoney
		}
	}(), slate.Variants = function() {
		function Variants(options) {
			this.$container = options.$container, this.product = options.product, this.singleOptionSelector = options.singleOptionSelector, this.originalSelectorId = options.originalSelectorId, this.enableHistoryState = options.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
		}
		return Variants.prototype = _.assignIn({}, Variants.prototype, {
			_getCurrentOptions: function() {
				var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
					var $element = $(element),
						type = $element.attr("type"),
						currentOption = {};
					return type === "radio" || type === "checkbox" ? $element[0].checked ? (currentOption.value = $element.val(), currentOption.index = $element.data("index"), currentOption) : !1 : (currentOption.value = $element.val(), currentOption.index = $element.data("index"), currentOption)
				});
				return currentOptions = _.compact(currentOptions), currentOptions
			},
			_getVariantFromOptions: function() {
				var selectedValues = this._getCurrentOptions(),
					variants = this.product.variants;
				console.log(selectedValues);
				var found = _.find(variants, function(variant) {
					return selectedValues.every(function(values) {
						return _.isEqual(variant[values.index], values.value)
					})
				});
				return console.log(found), found
			},
			_onSelectChange: function() {
				var variant = this._getVariantFromOptions();
				this.$container.trigger({
					type: "variantChange",
					variant
				}), variant && (this._updateMasterSelect(variant), this._updateImages(variant), this._updatePrice(variant), this._updateSKU(variant), this.currentVariant = variant, this.enableHistoryState && this._updateHistoryState(variant))
			},
			_updateImages: function(variant) {
				var variantImage = variant.featured_image || {},
					currentVariantImage = this.currentVariant.featured_image || {};
				!variant.featured_image || variantImage.src === currentVariantImage.src || this.$container.trigger({
					type: "variantImageChange",
					variant
				})
			},
			_updatePrice: function(variant) {
				this.$container.trigger({
					type: "variantPriceChange",
					variant
				})
			},
			_updateSKU: function(variant) {
				variant.sku !== this.currentVariant.sku && this.$container.trigger({
					type: "variantSKUChange",
					variant
				})
			},
			_updateHistoryState: function(variant) {
				if (!(!history.replaceState || !variant)) {
					var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id,
						pastParam = this._getAllParameters("variant");
					pastParam != "" && (newurl += `&${pastParam}`), window.history.replaceState({
						path: newurl
					}, "", newurl)
				}
			},
			_getAllParameters: function(except = "none") {
				var result = "",
					tmp = [],
					idx = 0;
				return location.search.substr(1).split("&").forEach(function(item) {
					tmp = item.split("="), (except == "none" || tmp[0] !== except) && (idx != 0 && (result += "&"), idx++, result += `${tmp[0]}=${decodeURIComponent(tmp[1])}`)
				}), result
			},
			_updateMasterSelect: function(variant) {
				$(this.originalSelectorId, this.$container).val(variant.id), window.monetateQ = window.monetateQ || [], window.monetateQ.push(["setPageType", "product"]), window.monetateQ.push(["addProductDetails", [{
					productId: variant.sku,
					sku: variant.barcode
				}]]), window.monetateQ.push(["trackData"])
			}
		}), Variants
	}(), theme.Drawers = function() {
		function Drawer(id, position, options) {
			var defaults = {
				close: ".js-drawer-close",
				open: ".js-drawer-open-" + position,
				openClass: "js-drawer-open",
				dirOpenClass: "js-drawer-open-" + position
			};
			if (this.nodes = {
					$parent: $("html").add("body"),
					$page: $("#PageContainer")
				}, this.config = $.extend(defaults, options), this.position = position, this.$drawer = $("#" + id), !this.$drawer.length) return !1;
			this.drawerIsOpen = !1, this.init()
		}
		return Drawer.prototype.init = function() {
			$(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
		}, Drawer.prototype.open = function(evt) {
			var externalCall = !1;
			return evt ? evt.preventDefault() : externalCall = !0, evt && evt.stopPropagation && (evt.stopPropagation(), this.$activeSource = $(evt.currentTarget)), this.drawerIsOpen && !externalCall ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
				$container: this.$drawer,
				namespace: "drawer_focus"
			}), this.config.onDrawerOpen && typeof this.config.onDrawerOpen == "function" && (externalCall || this.config.onDrawerOpen()), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
		}, Drawer.prototype.close = function() {
			this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
				$container: this.$drawer,
				namespace: "drawer_focus"
			}), this.unbindEvents())
		}, Drawer.prototype.bindEvents = function() {
			this.nodes.$parent.on("keyup.drawer", $.proxy(function(evt) {
				return evt.keyCode === 27 ? (this.close(), !1) : !0
			}, this)), this.nodes.$page.on("touchmove.drawer", function() {
				return !1
			}), this.nodes.$page.on("click.drawer", $.proxy(function() {
				return this.close(), !1
			}, this))
		}, Drawer.prototype.unbindEvents = function() {
			this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
		}, Drawer
	}(), window.theme = window.theme || {}, theme.Header = function() {
		var selectors = {
				body: "body",
				navigation: "#AccessibleNav",
				siteNavHasDropdown: ".site-nav--has-dropdown",
				siteNavChildLinks: ".site-nav__child-link",
				siteNavActiveDropdown: ".site-nav--active-dropdown",
				siteNavLinkMain: ".site-nav__link--main",
				siteNavChildLink: ".site-nav__link--last"
			},
			config = {
				activeClass: "site-nav--active-dropdown",
				childLinkClass: "site-nav__child-link"
			},
			cache = {};

		function init() {
			cacheSelectors(), cache.$parents.on("click.siteNav", function(evt) {
				var $el = $(this);
				$el.hasClass(config.activeClass) || (evt.preventDefault(), evt.stopImmediatePropagation()), showDropdown($el)
			}), $(selectors.siteNavChildLink).on("focusout.siteNav", function() {
				setTimeout(function() {
					$(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length || hideDropdown(cache.$activeDropdown)
				})
			}), cache.$topLevel.on("focus.siteNav", function() {
				cache.$activeDropdown.length && hideDropdown(cache.$activeDropdown)
			}), cache.$subMenuLinks.on("click.siteNav", function(evt) {
				evt.stopImmediatePropagation()
			})
		}

		function cacheSelectors() {
			cache = {
				$nav: $(selectors.navigation),
				$topLevel: $(selectors.siteNavLinkMain),
				$parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
				$subMenuLinks: $(selectors.siteNavChildLinks),
				$activeDropdown: $(selectors.siteNavActiveDropdown)
			}
		}

		function showDropdown($el) {
			$el.addClass(config.activeClass), cache.$activeDropdown.length && hideDropdown(cache.$activeDropdown), cache.$activeDropdown = $el, setTimeout(function() {
				$(window).on("keyup.siteNav", function(evt) {
					evt.keyCode === 27 && hideDropdown($el)
				}), $(selectors.body).on("click.siteNav", function() {
					hideDropdown($el)
				})
			}, 250)
		}

		function hideDropdown($el) {
			$el.removeClass(config.activeClass), cache.$activeDropdown = $(selectors.siteNavActiveDropdown), $(selectors.body).off("click.siteNav"), $(window).off("keyup.siteNav")
		}

		function unload() {
			$(window).off(".siteNav"), cache.$parents.off(".siteNav"), cache.$subMenuLinks.off(".siteNav"), cache.$topLevel.off(".siteNav"), $(selectors.siteNavChildLink).off(".siteNav"), $(selectors.body).off(".siteNav")
		}
		return {
			init,
			unload
		}
	}(), window.theme = window.theme || {}, theme.MobileNav = function() {
		var classes = {
				mobileNavOpenIcon: "mobile-nav--open",
				mobileNavCloseIcon: "mobile-nav--close",
				subNavLink: "mobile-nav__sublist-link",
				return: "mobile-nav__return-btn",
				subNavActive: "is-active",
				subNavClosing: "is-closing",
				navOpen: "js-menu--is-open",
				subNavShowing: "sub-nav--is-open",
				thirdNavShowing: "third-nav--is-open",
				subNavToggleBtn: "js-toggle-submenu"
			},
			cache = {},
			isTransitioning, $activeSubNav, $activeTrigger, menuLevel = 1,
			mediaQuerySmall = "screen and (max-width: 749px)";

		function init() {
			cacheSelectors(), cache.$mobileNavToggle.on("click", toggleMobileNav), cache.$subNavToggleBtn.on("click.subNav", toggleSubNav), enquire.register(mediaQuerySmall, {
				unmatch: function() {
					closeMobileNav()
				}
			})
		}

		function toggleMobileNav() {
			cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon) ? closeMobileNav() : openMobileNav()
		}

		function cacheSelectors() {
			cache = {
				$pageContainer: $("#PageContainer"),
				$siteHeader: $(".site-header"),
				$mobileNavToggle: $(".js-mobile-nav-toggle"),
				$mobileNavContainer: $(".mobile-nav-wrapper"),
				$mobileNav: $("#MobileNav"),
				$subNavToggleBtn: $("." + classes.subNavToggleBtn)
			}
		}

		function openMobileNav() {
			var translateHeaderHeight = cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top;
			cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen), cache.$mobileNavContainer.css({
				transform: "translate3d(0, " + translateHeaderHeight + "px, 0)"
			}), cache.$mobileNavToggle.addClass(classes.mobileNavCloseIcon).removeClass(classes.mobileNavOpenIcon), $(window).on("keyup.mobileNav", function(evt) {
				evt.which === 27 && closeMobileNav()
			})
		}

		function closeMobileNav() {
			cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen), cache.$mobileNavContainer.css({
				transform: "translate3d(0, -100%, 0)"
			}), cache.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function() {
				slate.a11y.removeTrapFocus({
					$container: cache.$mobileNav,
					namespace: "navFocus"
				})
			}), cache.$mobileNavToggle.addClass(classes.mobileNavOpenIcon).removeClass(classes.mobileNavCloseIcon), $(window).off("keyup.mobileNav")
		}

		function toggleSubNav(evt) {
			if (!isTransitioning) {
				var $toggleBtn = $(evt.currentTarget),
					isReturn = $toggleBtn.hasClass(classes.return);
				isTransitioning = !0, isReturn ? ($("." + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]').removeClass(classes.subNavActive), $activeTrigger && $activeTrigger.length && $activeTrigger.removeClass(classes.subNavActive)) : $toggleBtn.addClass(classes.subNavActive), $activeTrigger = $toggleBtn, goToSubnav($toggleBtn.data("target"))
			}
		}

		function goToSubnav(target) {
			var $targetMenu = target ? $('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.$mobileNav;
			menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1, $activeSubNav && $activeSubNav.length && $activeSubNav.prepareTransition().addClass(classes.subNavClosing), $activeSubNav = $targetMenu;
			var $elementToFocus = target ? $targetMenu.find("." + classes.subNavLink + ":first") : $activeTrigger,
				translateMenuHeight = $targetMenu[0].scrollHeight;
			target || (translateMenuHeight = $targetMenu.outerHeight());
			var openNavClass = menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing,
				back_to_nav = 1;
			cache.$mobileNavContainer.hasClass(classes.thirdNavShowing) && (back_to_nav = 2), cache.$mobileNavContainer.css("height", translateMenuHeight).removeClass(classes.thirdNavShowing).addClass(openNavClass), target || (back_to_nav == 2 ? cache.$mobileNavContainer.removeClass(classes.thirdNavShowing) : cache.$mobileNavContainer.removeClass(classes.thirdNavShowing).removeClass(classes.subNavShowing)), cache.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function() {
				slate.a11y.trapFocus({
					$container: $targetMenu,
					$elementToFocus,
					namespace: "subNavFocus"
				}), cache.$mobileNavContainer.off(".subnavToggle"), isTransitioning = !1
			}), cache.$pageContainer.css({}), $activeSubNav.removeClass(classes.subNavClosing)
		}
		return {
			init,
			closeMobileNav
		}
	}(jQuery), window.theme = window.theme || {}, theme.Search = function() {
		var selectors = {
				search: ".search",
				searchSubmit: ".search__submit",
				searchInput: ".search__input",
				siteHeader: ".site-header",
				siteHeaderSearchToggle: ".site-header__search-toggle",
				siteHeaderSearch: ".site-header__search",
				searchDrawer: ".search-bar",
				searchDrawerInput: ".search-bar__input",
				searchHeader: ".search-header",
				searchHeaderInput: ".search-header__input",
				searchHeaderSubmit: ".search-header__submit",
				mobileNavWrapper: ".mobile-nav-wrapper"
			},
			classes = {
				focus: "search--focus",
				mobileNavIsOpen: "js-menu--is-open"
			};

		function init() {
			$(selectors.siteHeader).length && (initDrawer(), searchSubmit(), $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on("focus blur", function() {
				$(selectors.searchHeader).toggleClass(classes.focus)
			}), $(selectors.siteHeaderSearchToggle).on("click", function() {
				var searchHeight = $(selectors.siteHeader).outerHeight(),
					searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
				$(selectors.searchDrawer).css({
					height: searchHeight + "px",
					top: searchOffset + "px"
				})
			}))
		}

		function initDrawer() {
			$("#PageContainer").addClass("drawer-page-content"), $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false"), theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
				onDrawerOpen: searchDrawerFocus
			})
		}

		function searchDrawerFocus() {
			searchFocus($(selectors.searchDrawerInput)), $(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen) && theme.MobileNav.closeMobileNav()
		}

		function searchFocus($el) {
			$el.focus(), $el[0].setSelectionRange(0, $el[0].value.length)
		}

		function searchSubmit() {
			$(selectors.searchSubmit).on("click", function(evt) {
				var $el = $(evt.target),
					$input = $el.parents(selectors.search).find(selectors.searchInput);
				$input.val().length === 0 && (evt.preventDefault(), searchFocus($input))
			})
		}
		return {
			init
		}
	}(),
	function() {
		var selectors = {
				backButton: ".return-link"
			},
			$backButton = $(selectors.backButton);
		if (!document.referrer || !$backButton.length || !window.history.length) return;
		$backButton.one("click", function(evt) {
			evt.preventDefault();
			var referrerDomain = urlDomain(document.referrer),
				shopDomain = urlDomain(window.location.href);
			return shopDomain === referrerDomain && history.back(), !1
		});

		function urlDomain(url) {
			var anchor = document.createElement("a");
			return anchor.ref = url, anchor.hostname
		}
	}(), theme.Slideshow = function() {
		this.$slideshow = null;
		var classes = {
			wrapper: "slideshow-wrapper",
			slideshow: "slideshow",
			currentSlide: "slick-current",
			video: "slideshow__video",
			videoBackground: "slideshow__video--background",
			closeVideoBtn: "slideshow__video-control--close",
			pauseButton: "slideshow__pause",
			isPaused: "is-paused"
		};

		function slideshow(el) {
			this.$slideshow = $(el), this.$wrapper = this.$slideshow.closest("." + classes.wrapper), this.$pause = this.$wrapper.find("." + classes.pauseButton), this.settings = {
				accessibility: !0,
				arrows: this.$slideshow.data("arrows"),
				dots: this.$slideshow.data("dots"),
				fade: !0,
				draggable: !0,
				touchThreshold: 20,
				autoplay: this.$slideshow.data("autoplay"),
				autoplaySpeed: this.$slideshow.data("speed")
			}, console.log(this.settings), this.$slideshow.on("beforeChange", beforeChange.bind(this)), this.$slideshow.on("init", slideshowA11y.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this.togglePause.bind(this))
		}

		function slideshowA11y(event, obj) {
			var $slider = obj.$slider,
				$list = obj.$list,
				$wrapper = this.$wrapper,
				autoplay = this.settings.autoplay;
			$list.removeAttr("aria-live"), $wrapper.on("focusin", function(evt) {
				$wrapper.has(evt.target).length && ($list.attr("aria-live", "polite"), autoplay && $slider.slick("slickPause"))
			}), $wrapper.on("focusout", function(evt) {
				if ($wrapper.has(evt.target).length && ($list.removeAttr("aria-live"), autoplay)) {
					if ($(evt.target).hasClass(classes.closeVideoBtn)) return;
					$slider.slick("slickPlay")
				}
			}), obj.$dots && obj.$dots.on("keydown", function(evt) {
				evt.which === 37 && $slider.slick("slickPrev"), evt.which === 39 && $slider.slick("slickNext"), (evt.which === 37 || evt.which === 39) && obj.$dots.find(".slick-active button").focus()
			})
		}

		function beforeChange(event, slick, currentSlide, nextSlide) {
			var $slider = slick.$slider,
				$currentSlide = $slider.find("." + classes.currentSlide),
				$nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
			if (isVideoInSlide($currentSlide)) {
				var $currentVideo = $currentSlide.find("." + classes.video),
					currentVideoId = $currentVideo.attr("id");
				theme.SlideshowVideo.pauseVideo(currentVideoId), $currentVideo.attr("tabindex", "-1")
			}
			if (isVideoInSlide($nextSlide)) {
				var $video = $nextSlide.find("." + classes.video),
					videoId = $video.attr("id"),
					isBackground = $video.hasClass(classes.videoBackground);
				isBackground ? theme.SlideshowVideo.playVideo(videoId) : $video.attr("tabindex", "0")
			}
		}

		function isVideoInSlide($slide) {
			return $slide.find("." + classes.video).length
		}
		slideshow.prototype.togglePause = function() {
			var slideshowSelector = getSlideshowId(this.$pause);
			this.$pause.hasClass(classes.isPaused) ? (this.$pause.removeClass(classes.isPaused), $(slideshowSelector).slick("slickPlay")) : (this.$pause.addClass(classes.isPaused), $(slideshowSelector).slick("slickPause"))
		};

		function getSlideshowId($el) {
			return "#Slideshow-" + $el.data("id")
		}
		return slideshow
	}();

function onYouTubeIframeAPIReady() {
	theme.SlideshowVideo.loadVideos()
}
theme.SlideshowVideo = function() {
		var autoplayCheckComplete = !1,
			autoplayAvailable = !1,
			playOnClickChecked = !1,
			playOnClick = !1,
			youtubeLoaded = !1,
			videos = {},
			videoPlayers = [],
			videoOptions = {
				ratio: 16 / 9,
				playerVars: {
					iv_load_policy: 3,
					modestbranding: 1,
					autoplay: 0,
					controls: 0,
					showinfo: 0,
					wmode: "opaque",
					branding: 0,
					autohide: 0,
					rel: 0
				},
				events: {
					onReady: onPlayerReady,
					onStateChange: onPlayerChange
				}
			},
			classes = {
				playing: "video-is-playing",
				paused: "video-is-paused",
				loading: "video-is-loading",
				loaded: "video-is-loaded",
				slideshowWrapper: "slideshow-wrapper",
				slide: "slideshow__slide",
				slideBackgroundVideo: "slideshow__slide--background-video",
				slideDots: "slick-dots",
				videoChrome: "slideshow__video--chrome",
				videoBackground: "slideshow__video--background",
				playVideoBtn: "slideshow__video-control--play",
				closeVideoBtn: "slideshow__video-control--close",
				currentSlide: "slick-current",
				slickClone: "slick-cloned",
				supportsAutoplay: "autoplay",
				supportsNoAutoplay: "no-autoplay"
			};

		function init($video) {
			if ($video.length && (videos[$video.attr("id")] = {
					id: $video.attr("id"),
					videoId: $video.data("id"),
					type: $video.data("type"),
					status: $video.data("type") === "chrome" ? "closed" : "background",
					videoSelector: $video.attr("id"),
					$parentSlide: $video.closest("." + classes.slide),
					$parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
					controls: $video.data("type") === "background" ? 0 : 1,
					slideshow: $video.data("slideshow")
				}, !youtubeLoaded)) {
				var tag = document.createElement("script");
				tag.src = "https://www.youtube.com/iframe_api";
				var firstScriptTag = document.getElementsByTagName("script")[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
			}
		}

		function customPlayVideo(playerId) {
			!playOnClickChecked && !playOnClick || playerId && typeof videoPlayers[playerId].playVideo == "function" && privatePlayVideo(playerId)
		}

		function pauseVideo(playerId) {
			videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo == "function" && videoPlayers[playerId].pauseVideo()
		}

		function loadVideos() {
			for (var key in videos)
				if (videos.hasOwnProperty(key)) {
					var args = $.extend({}, videoOptions, videos[key]);
					args.playerVars.controls = args.controls, videoPlayers[key] = new YT.Player(key, args)
				} initEvents(), youtubeLoaded = !0
		}

		function loadVideo(key) {
			if (youtubeLoaded) {
				var args = $.extend({}, videoOptions, videos[key]);
				args.playerVars.controls = args.controls, videoPlayers[key] = new YT.Player(key, args), initEvents()
			}
		}

		function privatePlayVideo(id, clicked) {
			var videoData = videos[id],
				player = videoPlayers[id],
				$slide = videos[id].$parentSlide;
			if (playOnClick) setAsPlaying(videoData);
			else if (clicked || autoplayCheckComplete && autoplayAvailable) {
				$slide.removeClass(classes.loading), setAsPlaying(videoData), player.playVideo();
				return
			}
			autoplayCheckComplete || autoplayCheckFunction(player, $slide)
		}

		function setAutoplaySupport(supported) {
			var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
			$(document.documentElement).addClass(supportClass), supported || (playOnClick = !0), autoplayCheckComplete = !0
		}

		function autoplayCheckFunction(player, $slide) {
			player.playVideo(), autoplayTest(player).then(function() {
				setAutoplaySupport(!0)
			}).fail(function() {
				setAutoplaySupport(!1), player.stopVideo()
			}).always(function() {
				autoplayCheckComplete = !0, $slide.removeClass(classes.loading)
			})
		}

		function autoplayTest(player) {
			var deferred = $.Deferred(),
				wait, timeout;
			return wait = setInterval(function() {
				player.getCurrentTime() <= 0 || (autoplayAvailable = !0, clearInterval(wait), clearTimeout(timeout), deferred.resolve())
			}, 500), timeout = setTimeout(function() {
				clearInterval(wait), deferred.reject()
			}, 4e3), deferred
		}

		function playOnClickCheck() {
			playOnClickChecked || (($(window).width() < 750 || window.mobileCheck()) && (playOnClick = !0), playOnClick && setAutoplaySupport(!1), playOnClickChecked = !0)
		}

		function onPlayerReady(evt) {
			evt.target.setPlaybackQuality("hd1080");
			var videoData = getVideoOptions(evt);
			switch (playOnClickCheck(), $("#" + videoData.id).attr("tabindex", "-1"), sizeBackgroundVideos(), videoData.type) {
				case "background-chrome":
				case "background":
					evt.target.mute(), videoData.$parentSlide.hasClass(classes.currentSlide) && privatePlayVideo(videoData.id);
					break
			}
			videoData.$parentSlide.addClass(classes.loaded)
		}

		function onPlayerChange(evt) {
			var videoData = getVideoOptions(evt);
			switch (evt.data) {
				case 0:
					setAsFinished(videoData);
					break;
				case 1:
					setAsPlaying(videoData);
					break;
				case 2:
					setAsPaused(videoData);
					break
			}
		}

		function setAsFinished(videoData) {
			switch (videoData.type) {
				case "background":
					videoPlayers[videoData.id].seekTo(0);
					break;
				case "background-chrome":
					videoPlayers[videoData.id].seekTo(0), closeVideo(videoData.id);
					break;
				case "chrome":
					closeVideo(videoData.id);
					break
			}
		}

		function setAsPlaying(videoData) {
			var $slideshow = videoData.$parentSlideshowWrapper,
				$slide = videoData.$parentSlide;
			if ($slide.removeClass(classes.loading), videoData.status !== "background") {
				switch ($("#" + videoData.id).attr("tabindex", "0"), videoData.type) {
					case "chrome":
					case "background-chrome":
						$slideshow.removeClass(classes.paused).addClass(classes.playing), $slide.removeClass(classes.paused).addClass(classes.playing);
						break
				}
				$slide.find("." + classes.closeVideoBtn).focus()
			}
		}

		function setAsPaused(videoData) {
			var $slideshow = videoData.$parentSlideshowWrapper,
				$slide = videoData.$parentSlide;
			if (videoData.type === "background-chrome") {
				closeVideo(videoData.id);
				return
			}
			videoData.status !== "closed" && videoData.type !== "background" && ($slideshow.addClass(classes.paused), $slide.addClass(classes.paused)), videoData.type === "chrome" && videoData.status === "closed" && ($slideshow.removeClass(classes.paused), $slide.removeClass(classes.paused)), $slideshow.removeClass(classes.playing), $slide.removeClass(classes.playing)
		}

		function closeVideo(playerId) {
			var videoData = videos[playerId],
				$slideshow = videoData.$parentSlideshowWrapper,
				$slide = videoData.$parentSlide,
				classesToRemove = [classes.pause, classes.playing].join(" ");
			switch ($("#" + videoData.id).attr("tabindex", "-1"), videoData.status = "closed", videoData.type) {
				case "background-chrome":
					videoPlayers[playerId].mute(), setBackgroundVideo(playerId);
					break;
				case "chrome":
					videoPlayers[playerId].stopVideo(), setAsPaused(videoData);
					break
			}
			$slideshow.removeClass(classesToRemove), $slide.removeClass(classesToRemove)
		}

		function getVideoOptions(evt) {
			return videos[evt.target.a.id]
		}

		function startVideoOnClick(playerId) {
			var videoData = videos[playerId];
			switch (videoData.$parentSlide.addClass(classes.loading), videoData.status = "open", videoData.type) {
				case "background-chrome":
					unsetBackgroundVideo(playerId, videoData), videoPlayers[playerId].unMute(), privatePlayVideo(playerId, !0);
					break;
				case "chrome":
					privatePlayVideo(playerId, !0);
					break
			}
			$(document).on("keydown.videoPlayer", function(evt) {
				evt.keyCode === 27 && closeVideo(playerId)
			})
		}

		function sizeBackgroundVideos() {
			$("." + classes.videoBackground).each(function(index, el) {
				sizeBackgroundVideo($(el))
			})
		}

		function sizeBackgroundVideo($player) {
			var $slide = $player.closest("." + classes.slide);
			if (!$slide.hasClass(classes.slickClone)) {
				var slideWidth = $slide.width(),
					playerWidth = $player.width(),
					playerHeight = $player.height();
				slideWidth / videoOptions.ratio < playerHeight ? (playerWidth = Math.ceil(playerHeight * videoOptions.ratio), $player.width(playerWidth).height(playerHeight).css({
					left: (slideWidth - playerWidth) / 2,
					top: 0
				})) : (playerHeight = Math.ceil(slideWidth / videoOptions.ratio), $player.width(slideWidth).height(playerHeight).css({
					left: 0,
					top: (playerHeight - playerHeight) / 2
				})), $player.prepareTransition().addClass(classes.loaded)
			}
		}

		function unsetBackgroundVideo(playerId) {
			$("#" + playerId).removeAttr("style").removeClass(classes.videoBackground).addClass(classes.videoChrome), videos[playerId].$parentSlideshowWrapper.removeClass(classes.slideBackgroundVideo).addClass(classes.playing), videos[playerId].$parentSlide.removeClass(classes.slideBackgroundVideo).addClass(classes.playing), videos[playerId].status = "open"
		}

		function setBackgroundVideo(playerId) {
			var $player = $("#" + playerId).addClass(classes.videoBackground).removeClass(classes.videoChrome);
			videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo), videos[playerId].status = "background", sizeBackgroundVideo($player)
		}

		function initEvents() {
			$(document).on("click.videoPlayer", "." + classes.playVideoBtn, function(evt) {
				var playerId = $(evt.currentTarget).data("controls");
				startVideoOnClick(playerId)
			}), $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function(evt) {
				var playerId = $(evt.currentTarget).data("controls");
				closeVideo(playerId)
			}), $(window).on("resize.videoPlayer", $.debounce(250, function() {
				youtubeLoaded && sizeBackgroundVideos()
			}))
		}

		function removeEvents() {
			$(document).off(".videoPlayer"), $(window).off(".videoPlayer")
		}
		return {
			init,
			loadVideos,
			loadVideo,
			playVideo: customPlayVideo,
			pauseVideo,
			removeEvents
		}
	}(),
	function() {
		var $filterBy = $("#BlogTagFilter");
		$filterBy.length && $filterBy.on("change", function() {
			location.href = $(this).val()
		})
	}(), window.theme = theme || {}, theme.customerTemplates = function() {
		function initEventListeners() {
			$("#RecoverPassword").on("click", function(evt) {
				evt.preventDefault(), toggleRecoverPasswordForm()
			}), $("#HideRecoverPasswordLink").on("click", function(evt) {
				evt.preventDefault(), toggleRecoverPasswordForm()
			})
		}

		function toggleRecoverPasswordForm() {
			$("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
		}

		function resetPasswordSuccess() {
			var $formState = $(".reset-password-success");
			$formState.length && $("#ResetSuccess").removeClass("hide")
		}

		function customerAddressForm() {
			var $newAddressForm = $("#AddressNewForm");
			$newAddressForm.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
				hideElement: "AddressProvinceContainerNew"
			}), $(".address-country-option").each(function() {
				var formId = $(this).data("form-id"),
					countrySelector = "AddressCountry_" + formId,
					provinceSelector = "AddressProvince_" + formId,
					containerSelector = "AddressProvinceContainer_" + formId;
				new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
					hideElement: containerSelector
				})
			}), $(".address-new-toggle").on("click", function() {
				$newAddressForm.toggleClass("hide")
			}), $(".address-edit-toggle").on("click", function() {
				var formId = $(this).data("form-id");
				$("#EditAddress_" + formId).toggleClass("hide")
			}), $(".address-delete").on("click", function() {
				var $el = $(this),
					formId = $el.data("form-id"),
					confirmMessage = $el.data("confirm-message");
				confirm(confirmMessage || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + formId, {
					parameters: {
						_method: "delete"
					}
				})
			}))
		}

		function checkUrlHash() {
			var hash = window.location.hash;
			hash === "#recover" && toggleRecoverPasswordForm()
		}
		return {
			init: function() {
				checkUrlHash(), initEventListeners(), resetPasswordSuccess(), customerAddressForm()
			}
		}
	}(), window.theme = window.theme || {}, theme.Cart = function() {
		var selectors = {
				edit: ".js-edit-toggle"
			},
			config = {
				showClass: "cart__update--show",
				showEditClass: "cart__edit--active"
			};

		function Cart(container) {
			this.$container = $(container), this.$edit = $(selectors.edit, this.$container), this.$edit.on("click", this._onEditClick.bind(this))
		}
		return Cart.prototype = _.assignIn({}, Cart.prototype, {
			onUnload: function() {
				this.$edit.off("click", this._onEditClick)
			},
			_onEditClick: function(evt) {
				var $evtTarget = $(evt.target),
					$updateLine = $("." + $evtTarget.data("target"));
				$evtTarget.toggleClass(config.showEditClass), $updateLine.toggleClass(config.showClass)
			}
		}), Cart
	}(), window.theme = window.theme || {}, theme.Filters = function() {
		var constants = {
				SORT_BY: "sort_by"
			},
			selectors = {
				filterSelection: ".filters-toolbar__input--filter",
				sortSelection: ".filters-toolbar__input--sort",
				defaultSort: ".collection-header__default-sort"
			};

		function Filters(container) {
			var $container = this.$container = $(container);
			this.$filterSelect = $(selectors.filterSelection, $container), this.$sortSelect = $(selectors.sortSelection, $container), this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container)), this.defaultSort = this._getDefaultSortValue(), this._resizeSelect(this.$selects), this.$selects.removeClass("hidden"), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this))
		}
		return Filters.prototype = _.assignIn({}, Filters.prototype, {
			_onSortChange: function(evt) {
				var sort = this._sortValue();
				sort.length ? window.location.search = sort : window.location.href = window.location.href.replace(window.location.search, ""), this._resizeSelect($(evt.target))
			},
			_onFilterChange: function(evt) {
				window.location.href = this.$filterSelect.val() + window.location.search, this._resizeSelect($(evt.target))
			},
			_getSortValue: function() {
				return this.$sortSelect.val() || this.defaultSort
			},
			_getDefaultSortValue: function() {
				return $(selectors.defaultSort, this.$container).val()
			},
			_sortValue: function() {
				var sort = this._getSortValue(),
					query = "";
				return sort !== this.defaultSort && (query = constants.SORT_BY + "=" + sort), query
			},
			_resizeSelect: function($selection) {
				$selection.each(function() {
					var $this = $(this),
						arrowWidth = 10,
						text = $this.find("option:selected").text(),
						$test = $("<span>").html(text);
					$test.appendTo("body");
					var width = $test.width();
					$test.remove(), $this.width(width + arrowWidth)
				})
			},
			onUnload: function() {
				this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange)
			}
		}), Filters
	}(), window.theme = window.theme || {}, theme.HeaderSection = function() {
		function Header() {
			theme.Header.init(), theme.MobileNav.init(), theme.Search.init()
		}
		return Header.prototype = _.assignIn({}, Header.prototype, {
			onUnload: function() {
				theme.Header.unload()
			}
		}), Header
	}(), theme.Maps = function() {
		var config = {
				zoom: 14
			},
			apiStatus = null,
			mapsToLoad = [],
			key = theme.mapKey ? theme.mapKey : "";

		function Map(container) {
			this.$container = $(container), apiStatus === "loaded" ? this.createMap() : (mapsToLoad.push(this), apiStatus !== "loading" && (apiStatus = "loading", typeof window.google > "u" && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + key).then(function() {
				apiStatus = "loaded", initAllMaps()
			})))
		}

		function initAllMaps() {
			$.each(mapsToLoad, function(index, instance) {
				instance.createMap()
			})
		}

		function geolocate($map) {
			var deferred = $.Deferred(),
				geocoder = new google.maps.Geocoder,
				address = $map.data("address-setting");
			return geocoder.geocode({
				address
			}, function(results, status2) {
				status2 !== google.maps.GeocoderStatus.OK && deferred.reject(status2), deferred.resolve(results)
			}), deferred
		}
		return Map.prototype = _.assignIn({}, Map.prototype, {
			createMap: function() {
				var $map = this.$container.find(".map-section__container");
				return geolocate($map).then(function(results) {
					var mapOptions = {
							zoom: config.zoom,
							center: results[0].geometry.location,
							disableDefaultUI: !0
						},
						map = this.map = new google.maps.Map($map[0], mapOptions),
						center = this.center = map.getCenter(),
						marker = new google.maps.Marker({
							map,
							position: map.getCenter()
						});
					google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
						google.maps.event.trigger(map, "resize"), map.setCenter(center)
					}))
				}.bind(this)).fail(function() {
					var errorMessage;
					switch (status) {
						case "ZERO_RESULTS":
							errorMessage = theme.strings.addressNoResults;
							break;
						case "OVER_QUERY_LIMIT":
							errorMessage = theme.strings.addressQueryLimit;
							break;
						default:
							errorMessage = theme.strings.addressError;
							break
					}
					$map.parent().addClass("page-width map-section--load-error").html('<div class="errors text-center">' + errorMessage + "</div>")
				})
			},
			onUnload: function() {
				google.maps.event.clearListeners(this.map, "resize")
			}
		}), Map
	}();

function gm_authFailure() {
	$(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>")
}
theme.Product = function() {
	function Product(container) {
		var $container = this.$container = $(container),
			sectionId = $container.attr("data-section-id");
		this.settings = {
			mediaQueryMediumUp: "screen and (min-width: 750px)",
			mediaQuerySmall: "screen and (max-width: 749px)",
			bpSmall: !1,
			enableHistoryState: $container.data("enable-history-state") || !1,
			imageSize: null,
			imageZoomSize: null,
			namespace: ".slideshow-" + sectionId,
			sectionId,
			sliderActive: !1,
			zoomEnabled: !1,
			comingSoon: $container.data("comingsoon") || !1
		}, this.selectors = {
			addToCart: "#AddToCart-" + sectionId,
			addToCartText: "#AddToCartText-" + sectionId,
			comparePrice: "#ComparePrice-" + sectionId,
			originalPrice: "#ProductPrice-" + sectionId,
			SKU: ".variant-sku",
			originalPriceWrapper: ".product-price__price-" + sectionId,
			originalSelectorId: "#ProductSelect-" + sectionId,
			productFeaturedImage: "#FeaturedImage-" + sectionId,
			productImageWrap: "#FeaturedImageZoom-" + sectionId,
			productPrices: ".product-single__price-" + sectionId,
			productThumbImages: ".product-single__thumbnail--" + sectionId,
			productThumbs: ".product-single__thumbnails-" + sectionId,
			saleClasses: "product-price__sale product-price__sale--single",
			saleLabel: ".product-price__sale-label-" + sectionId,
			singleOptionSelector: ".single-option-selector-" + sectionId
		}, $("#ProductJson-" + sectionId).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML), this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass("js-zoom-enabled"), this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr("src")), this.settings.zoomEnabled && (this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data("zoom"))), this._initBreakpoints(), this._stringOverrides(), this._initVariants(), this._initImageSwitch(), this._setActiveThumbnail(), theme.Images.preload(this.productSingleObject.images, this.settings.imageSize))
	}
	Product.prototype = _.assignIn({}, Product.prototype, {
		_stringOverrides: function() {
			theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
		},
		_initBreakpoints: function() {
			var self = this;
			enquire.register(this.settings.mediaQuerySmall, {
				match: function() {
					$(self.selectors.productThumbImages).length > 3, self.settings.zoomEnabled && _destroyZoom($(self.selectors.productImageWrap)), self.settings.bpSmall = !0
				},
				unmatch: function() {
					self.settings.sliderActive, self.settings.bpSmall = !1
				}
			}), enquire.register(this.settings.mediaQueryMediumUp, {
				match: function() {
					self.settings.zoomEnabled && _enableZoom($(self.selectors.productImageWrap))
				}
			})
		},
		_initVariants: function() {
			var options = {
				$container: this.$container,
				enableHistoryState: this.$container.data("enable-history-state") || !1,
				singleOptionSelector: this.selectors.singleOptionSelector,
				originalSelectorId: this.selectors.originalSelectorId,
				product: this.productSingleObject
			};
			this.variants = new slate.Variants(options), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
		},
		_initImageSwitch: function() {
			if ($(this.selectors.productThumbImages).length) {
				var self = this;
				$(this.selectors.productThumbImages).on("click", function(evt) {
					evt.preventDefault();
					var $el = $(this),
						imageSrc = $el.attr("href"),
						zoomSrc = $el.data("zoom"),
						varSrc = $el.data("varattach"),
						containId = $el.data("sectionid"),
						$container = $("#ProductSection-" + containId),
						crossClick = $container.data("crossclick");
					if (self._switchImage(imageSrc, zoomSrc), self._setActiveThumbnail(imageSrc), varSrc !== void 0 && crossClick == "allow") {
						var originalSelectorId = $container.find("#ProductSelect-" + containId);
						originalSelectorId.val(varSrc).trigger("change");
						var form = $container.find("form.product-form-" + containId),
							prodJson = JSON.parse(document.getElementById("ProductJson-" + containId).innerHTML),
							prodSpecificVar = prodJson.variants,
							matches = jQuery.grep(prodSpecificVar, function(item) {
								return item.id === varSrc
							});
						if (matches.length)
							for (var i = 0, length = matches[0].options.length; i < length; i++) {
								var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + matches[0].options[i] + '"]');
								if (radioButton.size()) radioButton.trigger("click");
								else {
									var j = i + 1;
									form.find('.single-option-selector[data-index="option' + j + '"] option[value="' + matches[0].options[i] + '"]').prop("selected", !0).trigger("change")
								}
							}
					}
				})
			}
		},
		_setActiveThumbnail: function(src) {
			var activeClass = "active-thumb";
			typeof src > "u" && (src = $(this.selectors.productFeaturedImage).attr("src"));
			var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
			$(this.selectors.productThumbImages).removeClass(activeClass), $thumbnail.addClass(activeClass);

			function slide_select(a) {
				return a.closest("li").filter(":not(.slick-cloned)").data("slick-index")
			}
			slide_select($thumbnail) !== void 0 && $(this.selectors.productThumbs).slick("slickGoTo", slide_select($thumbnail))
		},
		_switchImage: function(image, zoomImage) {
			var zoomInitiated = this.settings.zoomEnabled,
				zoomSmall = this.settings.bpSmall,
				zoomImageWrap = $(this.selectors.productImageWrap);
			$(this.selectors.productFeaturedImage).fadeOut(350, function() {
				$(this).attr("src", image).fadeIn(350), zoomInitiated && _destroyZoom(zoomImageWrap), !zoomSmall && zoomInitiated && zoomImage && (zoomImageWrap.data("zoom", zoomImage), _enableZoom(zoomImageWrap))
			})
		},
		_initThumbnailSlider: function() {
			var options = {
				slidesToShow: 4,
				slidesToScroll: 3,
				infinite: !1,
				prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
				nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
				responsive: [{
					breakpoint: 321,
					settings: {
						slidesToShow: 3
					}
				}]
			};
			$(this.selectors.productThumbs).slick(options), this.settings.sliderActive = !0
		},
		_destroyThumbnailSlider: function() {
			$(this.selectors.productThumbs).slick("unslick"), this.settings.sliderActive = !1
		},
		_updateAddToCart: function(evt) {
			var variant = evt.variant
		},
		_updateImages: function(evt) {
			var variant = evt.variant,
				sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize),
				zoomSizedImgUrl;
			this.settings.zoomEnabled && (zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize)), this._switchImage(sizedImgUrl, zoomSizedImgUrl), this._setActiveThumbnail(sizedImgUrl)
		},


// Debug mode toggle - set to true to enable price updates, false for console logs only
_priceUpdateEnabled: false,

_updatePrice: function(evt) {
    var variant = evt.variant;
    
    // console.log('=== PRICE UPDATE DEBUG MODE ===');
    // console.log('Price update enabled:', this._priceUpdateEnabled);
    console.log('Updating price for variant:', variant);
    // console.log('Variant price:', variant.price);
    // console.log('Variant compare_at_price:', variant.compare_at_price);
    
    // Update the original price display
    var formattedPrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
    console.log('Formatted price:', formattedPrice);
    
    if (this._priceUpdateEnabled) {
        $('.product-single__price .product-price__price').html(formattedPrice);
    } else {
        console.log('WOULD UPDATE: originalPrice element with:', formattedPrice);
    }
    
    // Check if this is a sale item (compare_at_price is higher than current price)
    var isOnSale = variant.compare_at_price > variant.price;
    console.log('Is on sale:', isOnSale);
    
    if (isOnSale) {
        // Show sale pricing
        var formattedComparePrice = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat);
        console.log('Formatted compare price:', formattedComparePrice);
        
        if (this._priceUpdateEnabled) {
            $('.product-single__price .cross-sale-price')
                .html(formattedComparePrice)
                .removeClass("hide");
            
            $(this.selectors.originalPriceWrapper)
                .addClass(this.selectors.saleClasses);
            
            $(this.selectors.saleLabel)
                .removeClass("hide");
            
            console.log('Applied sale styling');
        } else {
            // console.log('WOULD UPDATE: comparePrice element with:', formattedComparePrice);
            // console.log('WOULD REMOVE: "hide" class from comparePrice');
            // console.log('WOULD ADD:', this.selectors.saleClasses, 'to originalPriceWrapper');
            // console.log('WOULD REMOVE: "hide" class from saleLabel');
            // console.log('WOULD APPLY: sale styling');
        }
		
		$('.product-single__price .product-price__price').html(formattedPrice);
		$('.product-single__price .cross-sale-price').html(formattedComparePrice).removeClass("hide").css('display','inline');

    } else {
        // Hide sale pricing
        if (this._priceUpdateEnabled) {
            $(this.selectors.comparePrice).addClass("hide");
            $(this.selectors.saleLabel).addClass("hide");
            $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
            console.log('Removed sale styling');
        } else {
            // console.log('WOULD ADD: "hide" class to comparePrice');
            // console.log('WOULD ADD: "hide" class to saleLabel');
            // console.log('WOULD REMOVE:', this.selectors.saleClasses, 'from originalPriceWrapper');
            // console.log('WOULD REMOVE: sale styling');
        }
		$('.product-single__price .product-price__price').html(formattedPrice);
		$('.product-single__price .cross-sale-price').html('').addClass("hide").hide();
    }
    
    console.log('Price update completed');
    console.log('=== END PRICE UPDATE DEBUG ===');
},

// Helper method to toggle the price update mode
togglePriceUpdate: function(enabled) {
    this._priceUpdateEnabled = enabled;
    console.log('Price update mode:', enabled ? 'ENABLED' : 'DISABLED (debug only)');
},
      

		_updateSKU: function(evt) {
			var variant = evt.variant;
			$(this.selectors.SKU).html(variant.sku)
		},
		onUnload: function() {
			this.$container.off(this.settings.namespace)
		}
	});

	function _enableZoom($el) {
		var zoomUrl = $el.data("zoom");
		$el.zoom({
			url: zoomUrl
		})
	}

	function _destroyZoom($el) {
		$el.trigger("zoom.destroy")
	}
	return Product
}(), theme.Quotes = function() {
	var config = {
			mediaQuerySmall: "screen and (max-width: 749px)",
			mediaQueryMediumUp: "screen and (min-width: 750px)",
			slideCount: 0
		},
		defaults = {
			accessibility: !0,
			arrows: !1,
			dots: !0,
			autoplay: !1,
			touchThreshold: 20,
			slidesToShow: 3,
			slidesToScroll: 1
		};

	function Quotes(container) {
		var $container = this.$container = $(container),
			sectionId = $container.attr("data-section-id"),
			wrapper = this.wrapper = ".quotes-wrapper",
			slider = this.slider = "#Quotes-" + sectionId,
			$slider = $(slider, wrapper),
			sliderActive = !1,
			mobileOptions = $.extend({}, defaults, {
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: !0
			});
		config.slideCount = $slider.data("count"), config.slideShow = $slider.data("show"), config.slideCount < config.slideShow ? defaults.slidesToShow = config.slideCount : defaults.slidesToShow = config.slideShow, defaults.dots = $slider.data("dots"), defaults.arrows = $slider.data("arrows"), $slider.on("init", this.a11y.bind(this)), enquire.register(config.mediaQuerySmall, {
			match: function() {
				initSlider($slider, mobileOptions)
			}
		}), enquire.register(config.mediaQueryMediumUp, {
			match: function() {
				initSlider($slider, defaults)
			}
		});

		function initSlider(sliderObj, args) {
			sliderActive && (sliderObj.slick("unslick"), sliderActive = !1), sliderObj.slick(args), sliderActive = !0
		}
	}
	return Quotes.prototype = _.assignIn({}, Quotes.prototype, {
		onUnload: function() {
			enquire.unregister(config.mediaQuerySmall), enquire.unregister(config.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick")
		},
		onBlockSelect: function(evt) {
			var $slide = $(".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"),
				slideIndex = $slide.data("slick-index");
			$(this.slider, this.wrapper).slick("slickGoTo", slideIndex)
		},
		a11y: function(event, obj) {
			var $list = obj.$list,
				$wrapper = $(this.wrapper, this.$container);
			$list.removeAttr("aria-live"), $wrapper.on("focusin", function(evt) {
				$wrapper.has(evt.target).length && $list.attr("aria-live", "polite")
			}), $wrapper.on("focusout", function(evt) {
				$wrapper.has(evt.target).length && $list.removeAttr("aria-live")
			})
		}
	}), Quotes
}(), theme.slideshows = {}, theme.SlideshowSection = function() {
	function SlideshowSection(container) {
		var $container = this.$container = $(container),
			sectionId = $container.attr("data-section-id"),
			slideshow = this.slideshow = "#Slideshow-" + sectionId;
		$(".slideshow__video", slideshow).each(function() {
			var $el = $(this);
			theme.SlideshowVideo.init($el), theme.SlideshowVideo.loadVideo($el.attr("id"))
		}), theme.slideshows[slideshow] = new theme.Slideshow(slideshow)
	}
	return SlideshowSection
}(), theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
	onUnload: function() {
		delete theme.slideshows[this.slideshow]
	},
	onBlockSelect: function(evt) {
		var $slideshow = $(this.slideshow),
			$slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"),
			slideIndex = $slide.data("slick-index");
		$slideshow.slick("slickGoTo", slideIndex).slick("slickPause")
	},
	onBlockDeselect: function() {
		$(this.slideshow).slick("slickPlay")
	}
}), $(document).ready(function() {
	$(".mp-inline").magnificPopup({
		type: "inline",
		midClick: !0
	}), $(".equalize").matchHeight(), $(".tooltipped").tooltipster(), $().jetmenu({
		indicator: !1
	});

	function mobileToggler() {
		$(".hidden-sm-down").css("display") == "none" && $(".mobile-toggler").on("click", function(evt) {
			evt.stopImmediatePropagation(), $(this).next("ul").toggleClass("open")
		})
	}
	mobileToggler(), $(window).on("resize", function() {
		mobileToggler()
	});
	var sections = new theme.Sections;
	sections.register("cart-template", theme.Cart), sections.register("product", theme.Product), sections.register("collection-template", theme.Filters), sections.register("product-template", theme.Product), sections.register("header-section", theme.HeaderSection), sections.register("map", theme.Maps), sections.register("slideshow-section", theme.SlideshowSection), sections.register("quotes", theme.Quotes);
	var headerHeight = 40 - $("#shopify-section-header").outerHeight();
	const postDetails = document.querySelector(".product-single__photos"),
		postSidebar = document.querySelector(".product-single__content"),
		postSidebarContent = document.querySelector(".product-single__content > .product-single__meta"),
		controller = new ScrollMagic.Controller,
		scene = new ScrollMagic.Scene({
			triggerElement: postSidebar,
			triggerHook: 0,
			offset: headerHeight,
			duration: getDuration
		}).addTo(controller);
	window.matchMedia("(min-width: 992px)").matches && scene.setPin(postSidebar, {
		pushFollowers: !1
	}), console.log(controller), window.addEventListener("resize", () => {
		if (window.matchMedia("(min-width: 992px)").matches && $(".product-single .scrollmagic-pin-spacer").length === 0) {
			var headerHeight2 = 40 - $("#shopify-section-header").outerHeight();
			const postDetails2 = document.querySelector(".product-single__photos"),
				postSidebar2 = document.querySelector(".product-single__content"),
				postSidebarContent2 = document.querySelector(".product-single__content > .product-single__meta"),
				controller2 = new ScrollMagic.Controller;
			new ScrollMagic.Scene({
				triggerElement: postSidebar2,
				triggerHook: 0,
				offset: headerHeight2,
				duration: getDuration
			}).addTo(controller2).setPin(postSidebar2, {
				pushFollowers: !1
			})
		} else scene.destroy(!0), console.log(controller)
	});

	function getDuration() {
		return postDetails.offsetHeight - postSidebarContent.offsetHeight
	}
}), $(window).load(function() {
	var headerHeight = $("#shopify-section-header").outerHeight();
	$('a[href*="#"]:not([href="#"]):not(.mp-inline):not(.toggler):not(.noscroll)').click(function() {
		if ($("body").hasClass("template-page") && $(".shopify-section.index-section").attr("id") == "shopify-section-faq" && (headerHeight = $("#shopify-section-header").outerHeight() + $(this).outerHeight()), location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
			var target = $(this.hash);
			if (target = target.length ? target : $("[name=" + this.hash.slice(1) + "]"), target.length) return $("html, body").animate({
				scrollTop: target.offset().top - headerHeight
			}, 1e3, "swing"), $("html, body").bind("scroll mousedown DOMMouseScroll mousewheel keyup", function() {
				$("html, body").stop()
			}), !1
		}
	}), window.location.hash && window.location.hash != "#swym-wishlist" && (console.log("got hash"), $("html, body").animate({
		scrollTop: $(window.location.hash).offset().top - headerHeight + "px"
	}, 1e3, "swing"))
}), theme.init = function() {
	theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
	}), $('a[href="#"]').on("click", function(evt) {
		evt.preventDefault()
	})
}, $(theme.init), $(document).ready(function() {
	$(".collection-list-items").on("click", ".grid-view-item .swatch-element input", function() {
		var variant_image = $(this).data("variant-image"),
			variant_id = $(this).data("variant-id"),
			uri = $(this).closest(".grid-view-item").find(".grid-view-item__link").attr("href");
		uri.indexOf("?") > 0 && (uri = uri.substring(0, uri.indexOf("?"))), uri += "?variant=" + variant_id, $(this).closest(".grid-view-item").find(".grid-view-item__image").css("background-image", "url(" + variant_image + ")")
	}), $("body").on("click", ".grid-view-item .grid-view-item__nav", function() {
		var $el = $(this),
			$gridItem = $el.closest(".grid-view-item"),
			$imageItem = $gridItem.find(".grid-view-item__image"),
			prodID = $gridItem.data("productid"),
			imageJson = JSON.parse(document.getElementById("ImageJSON-" + prodID).innerHTML),
			imagelength = imageJson.length - 1,
			navDirection = $el.index(),
			increment = navDirection > 0 ? 1 : -1,
			curr_index = $imageItem.attr("data-index"),
			new_index = curr_index * 1 + increment,
			img = new Image;
			
		new_index > imagelength ? new_index = 0 : new_index < 0 && (new_index = imagelength), img.src = theme.Images.getSizedImageUrl(imageJson[new_index], "500x"), img.onload = function() {
			console.log("click here");
			$imageItem.fadeOut(250, function() {
				$(this).attr("data-index", new_index).css("background-image", "url(" + img.src + ")").fadeIn(250)
			})
			console.log("click here",new_index);
		}
	})
});
var rootLink = new RegExp(location.host);
$(document).ready(function() {
	var linkPattern = /^https?:\/\//i;
	$("a").each(function() {
		!linkPattern.test($(this).attr("href")) || $(this).attr("href").includes("dakine.com") ? $(this).attr("referrerpolicy", "origin") : $(this).attr("referrerpolicy", "no-referrer")
	})
}), $(document).ready(function() {
	window.matchMedia("(min-width: 767px)").matches && $(".gift-collection-slider").prepend("<div class='empty-slide'></div>"), $(".gift-collection-slider").slick({
		dots: !1,
		arrow: !0,
		infinite: !1,
		speed: 300,
		slidesToShow: 5.3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 769,
			settings: {
				slidesToShow: 2.3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: !0,
				centerPadding: "50px",
				arrow: !1
			}
		}]
	})
}), $(document).ready(function() {
	$(".gift-box-collection-rewamp-slider").slick({
		dots: !1,
		arrow: !0,
		infinite: !1,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 769,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: !0,
				centerPadding: "50px"
			}
		}]
	})
}), $(document).ready(function() {
	$(".slideshow_slider").slick({
		autoplay: !0,
		dots: !1,
		arrow: !0,
		infinite: !0,
		speed: 500,
		autoplaySpeed: 8e3,
		fade: !0
	})
}), $(document).ready(function() {
	$(".slideshow_slider_mobile").slick({
		autoplay: !0,
		arrow: !1,
		dots: !0,
		infinite: !0,
		speed: 500,
		autoplaySpeed: 8e3,
		fade: !0
	})
}), $(document).ready(function() {
	window.matchMedia("(min-width: 769px)").matches && $(".blog-slider").prepend("<div class='empty-slide'></div>"), $(".blog-slider").slick({
		dots: !1,
		arrow: !0,
		infinite: !1,
		speed: 300,
		slidesToShow: 6.3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 1100,
			settings: {
				slidesToShow: 3.3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 992,
			settings: {
				slidesToShow: 2.3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	}), $(".article-products-slider").slick({
		dots: !1,
		arrow: !0,
		infinite: !1,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 1100,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}]
	})
});
//# sourceMappingURL=/s/files/1/0242/3141/1792/t/381/assets/theme.js.map?v=1740508219